import reducer from "./reducers";
export { default as resourceActions } from "./actions";

export default reducer;